import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ReportVersionFactory } from '@shared/factories/report-version/report-version.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
// import html2canvas from 'html2canvas';

@Component({
  selector: 'report-graph',
  templateUrl: './report-graph.component.html'
})
export class ReportGraphComponent implements OnInit, OnChanges {
  risksFrom:any = ['initial', 'inherit', 'residual']
  reportGraph:any = {
    reportsState:{
      original:[]
    },
    reportsInvestigation:{
      original:[]
    },
    areaTitle: this.translate.instant('dashboard-reports.areas-concerned'),
    stateLoad: false,
    investigationLoad: false,
    informationTypology: false,
    donutOptions: {
      subType: 1,
      type: 'poll'
    },

    esgHeatMapData: [],
    hourStates:[
      {
          days: '00',
          hours: '20',
          minutes: '22',
          color: '#C43741'
      },{
          days: '15',
          hours: '23',
          minutes: '07',
          color: '#F1BC3E'
      },{
          days: '00',
          hours: '00',
          minutes: '00',
          color: '#F1923E'
      },{
          days: '00',
          hours: '17',
          minutes: '11',
          color: '#77D166'
      }
    ],
    uniqueList: []
  }
  constructor(private apiService: ApiServiceService,
    private reportVersion: ReportVersionFactory,
    private translate: AfTranslateFactory,
    private filterColumnService: FilterColumnService,
    private commonUtilsService: CommonUtilsService,
    private exportService: ExportServiceService,
    private loader: LoaderFactory) { }

  @Input() report: any = null;
  @Input() configurateReport: any = null;
  @Input() showResidualOption: Boolean = false;
  @Input() filterColumns: any = [];
  @Input() showDepartment: string = '';
  @Output() configureDepartmentList = new EventEmitter();

  ngOnInit(): void {
    let that: any = this.reportGraph;
    that.configurateReport = this.configurateReport;
    that.report = this.report;
    that.actualVersion = this.report.reportId === this.reportVersion.folderReportVersion || this.report.reportId === this.reportVersion.dashboardReportVersion;

    switch(true){
      case (that.report.reportId === 197 || that.actualVersion):
        this.getReportByType(1, 'state');
        this.getReportByType(2, 'investigation');
        this.getReportByType(3, 'typology');
        break;
      case (that.report.reportId === 205 || that.report.reportId === 206 || that.report.reportId === 207):
        this.getReportByType(1, 'esgHeatMaps');
        break;
      case (that.report.reportId === 194):
        this.getReportByType(1, 'initial');
        this.getReportByType(2, 'inherit');
        this.getReportByType(3, 'residual');
        that.configurateReport.type = 'risk'
        break;
      default:
        if(that.configurateReport.type === 4){
          this.getGraphtsTaskInfo();
          this.getGraphtsTaskAnualInfo();
          this.getReportByType('donoughtgraphic', 'other')
        }else {
            if(that.report.reportId === 180){
              this.getDrawHeatMapResidualInfo();
              this.getReportByType(1, 'donoughtGraphResidual');
              this.getReportByType(4, 'byRisk')

            }
            this.getDrawHeatMapInfo();
            this.getReportByType('donoughtgraphic', 'other')
        }
        break;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    let that:any = this.reportGraph;
    if(changes['showDepartment'] && changes['showDepartment'].currentValue !== '' && that.report.reportId === 194){
      let currentValue: any = changes['showDepartment'].currentValue;
      this.extractValues(currentValue)
      // this.extractSourceData(this.reportGraph.initialSourceData.filter((data:any)=>{ return data.departamento === currentValue})[0].sourceData, 'initial');
      // this.extractSourceData(this.reportGraph.inheritSourceData.filter((data:any)=>{ return data.departamento === currentValue})[0].sourceData, 'inherit');
      // this.extractSourceData(this.reportGraph.residualSourceData.filter((data:any)=>{ return data.departamento === currentValue})[0].sourceData, 'residual');
    }
  }
  extractValues(currentValue: string){
    for(let i = 0; i < this.risksFrom.length; i++){
      let typeFrom: string = this.risksFrom[i];
      for(let j = 0; j < this.reportGraph[typeFrom+'SourceData'].length; j++){
        let item:any = this.reportGraph[typeFrom+'SourceData'][j];
        if(item.departamento === currentValue){
          this.extractSourceData(item.sourceData, typeFrom);
          break;
        }
      }
    }
  }

  getReportByType(typeNumber:any, typeName:string){
    this.apiService.add(`reportgraphics/${this.reportGraph.report.reportObjectId}/${typeNumber}`, this.filterColumns)
      .then((data)=>{
        this.reportGraph.report.reportId === 194? this.setDataRisk(data, typeName) : this.setReportData(data, typeName, typeNumber);
        if(typeName === 'esgHeatMaps'){
          typeNumber++;
          if(typeNumber < 5){
            this.getReportByType(typeNumber, 'esgHeatMaps');
          }
        }
      })
  }

  setDataRisk(data:any, typeName: string){
    this.reportGraph[`${typeName}Data`] = data;
    this.reportGraph[`${typeName}SourceData`] = this.configureRiskSourceData(data.sourceData);
    this.extractSourceData(data.sourceData.slice(0,3), typeName)
  }

  configureRiskSourceData(sourceData:any){
    let groupByDepartment: any = [];

    if(this.reportGraph.uniqueList.length === 0){
      this.reportGraph.uniqueList = this.filterColumnService.extractList('departamento', sourceData);
      this.configureDepartmentList.emit({departmentList: this.reportGraph.uniqueList})
    }

    for(let i: number = 0; i < this.reportGraph.uniqueList.length; i++){
      let departamento = this.reportGraph.uniqueList[i].name;
      groupByDepartment.push({
        departamento: departamento,
        sourceData : sourceData.filter((dataItem:any)=>{ return dataItem.departamento === departamento})
      })
    }
    return groupByDepartment;

     // for(let i:number = 0; i < this.reportGraph.uniqueList.length; i++){
    //   let uniqueItem:any = this.reportGraph.uniqueList[i];
    //   uniqueItem.sourceData = sourceData.filter((item:any)=>{return item.departamento === uniqueItem.name});
    //   mapList.set(`${uniqueItem.name}-${typeName}`, uniqueItem)
    // }
    // return mapList;

  }

  extractSourceData(souceData:any, typeName:string){
    this.reportGraph[`${typeName}Data`].sourceData = souceData
    this.setReportData(this.reportGraph[`${typeName}Data`], typeName);
  }

  setReportData(data:any, typeName:string, typeNumber:number = 0){
    switch(typeName){
      case 'state':
        this.setReportState(data);
        break;
      case 'investigation':
        this.setReportInvestigation(data);
        break;
      case 'typology':
        this.setReportTypology(data);
        break;
      case 'esgHeatMaps':
        this.setReportEsgHeatMaps(data, typeNumber);
        break;
      case 'donoughtGraphResidual':
        this.setReportDonoughtGraphResidual(data);
        break;
      case 'byRisk':
        this.reportGraph.reportsbyRisk = this.setCrimeRisk(data)
        this.showResidualOption = Boolean(this.reportGraph.reportsbyRisk.length > 0)
        break;
      default:
        this.setReportDefault(data, typeName);
        break;
    }
  }

  setReportState(data:any){
    data.forEach((item:any) => {
      item.label = item.state;
      item.count = item.complaints;
    });
    this.reportGraph.reportsState = this.configureReportData(data);
    this.reportGraph.stateLoad = true;
  }

  setReportInvestigation(data:any){
    this.reportGraph.reportsInvestigation.original = this.configureInvestigationData(data);
    this.reportGraph.reportsInvestigation.data = data;
    this.reportGraph.investigationLoad = true;
  }

  setReportTypology(data:any){
    data.forEach((item:any) => {
      item.label = item.tipology;
      item.answers = item.complaints;
      item.percentage = item.complaintsPerc;
     });
     this.reportGraph.informationTypologyData = this.configureReportData(data);
     this.reportGraph.informationTypology = true;
  }

  setReportEsgHeatMaps(data:any, typeNumber:number){
    this.reportGraph.esgHeatMapData.push({
      graph: data,
      title: this.getEsgTitle(typeNumber),
      xAxxis:this.getXAxxis(typeNumber),
      yAxxis: this.getYAxxis(typeNumber)
    });
  }

  getEsgTitle(index:number){
    switch(index){
      case 1:
        return this.translate.instant('report-graph.risk-material-incident');
      case 2:
        return this.translate.instant('report-graph.stakeholder-impact');
      case 3:
        return this.translate.instant('report-graph.risk-impact');
      default:
        return this.translate.instant('report-graph.opportunity-impact');
    }
  }

  getXAxxis(index:number){
    switch(index){
      case 1:
        return this.translate.instant('report-graph.axxis-magnitude');
      default:
        return this.translate.instant('report-graph.axxis-probability');
    }
  }

  getYAxxis(index:number){
    switch(index){
      case 1:
      case 2:
        return this.translate.instant('report-graph.axxis-severite');
      default:
        return this.translate.instant('report-graph.axxis-magnitude');
    }
  }

  getDrawHeatMapInfo(){
      this.apiService.get('reportobjects/risksmapchart',this.reportGraph.report.reportObjectId)
          .then((data:any)=>{
              this.reportGraph.graphData = {
                graph: data,
                xAxxis: this.translate.instant('report-graph.axxis-impact'),
                yAxxis: this.translate.instant('report-graph.axxis-probability')
              }

          })
  }

  setReportDefault(data:any, type:string){
    this.reportGraph[`${type}GraphsData`] = this.configureData(data);
  }

  setReportDonoughtGraphResidual(data:any){
    this.reportGraph.otherGraphsResidualData = this.configureData(data);
    this.reportGraph.otherGraphsResidualData.graphicId = 'residual'
  }

  setCrimeRisk(data:any){
    let dataGraph: any = [];
    data.forEach((item:any) => {
      let configuredItem:any = {}
      switch(item.riesgoResidual){
        case 'BAJO':
          configuredItem.value = 2;
          configuredItem.color = '#4CAF50'
          configuredItem.typeRisk= this.translate.instant('report-graph.low-risk')
          break;
        case 'MEDIO':
          configuredItem.value = 4;
          configuredItem.color = '#FFC107'
          configuredItem.typeRisk= this.translate.instant('report-graph.medium-risk')
          break;

        case 'ALTO':
          configuredItem.value = 6;
          configuredItem.color = '#D32F2F'
          configuredItem.typeRisk= this.translate.instant('report-graph.high-risk')
          break;
      }
      configuredItem.label = item.escenarioRiesgo;
      configuredItem.dependencies = item.dependencias.indexOf('|') !== -1? item.dependencias.split('|') : [item.dependencias]
      configuredItem.id= this.commonUtilsService.createId()
      dataGraph.push(configuredItem);
    });
    return dataGraph;
  }

  getDrawHeatMapResidualInfo(){
      this.apiService.get('reportobjects/risksmapchartresidual',this.reportGraph.report.reportObjectId)
          .then((data:any)=>{
              this.reportGraph.graphResidualData ={
                graph: data,
                graphicId: 'residual',
                xAxxis: this.translate.instant('report-graph.axxis-impact'),
                yAxxis: this.translate.instant('report-graph.axxis-probability')
              }

          })
  }


  getGraphtsTaskInfo(){
      this.apiService.get('reportobjects/type4graphic1', this.reportGraph.report.reportObjectId)
          .then((data:any)=>{
              this.reportGraph.graphTaskData = [];
              this.reportGraph.graphTaskData.titles = [];
              this.reportGraph.graphTaskData.tipology = data;
              data.forEach((item:any) => {
                this.reportGraph.graphTaskData.titles.push(item.typology)
              });
          })
  }

  getGraphtsTaskAnualInfo(){
      this.apiService.get('reportobjects/type4graphic3', this.reportGraph.report.reportObjectId)
          .then((data)=>{
              this.reportGraph.graphTaskAnualData=[];
              this.reportGraph.graphTaskAnualData.month=data;
          },(error:any)=>{})
  }

  configureInvestigationData(data:any){
    let original:any = []
    for(let i = 0; i < data.length; i++){
      let amount:number = 0
      let amountPercent: number = 0
      let compliants: any = data[i].compliants;
      for(let j = 0; j < compliants.length; j++){
        amount+= compliants[j].complaints
        amountPercent += compliants[j].complaintsPerc
      }
      original.push({
        label: data[i].validation,
        color: '#00ff00',
        count: amount,
        complaints: compliants,
        complaintsPerc: amountPercent
      })
    }
    return original
  }

  configureReportData(data:any){
    let dataGraph:any = {
        data:[],
        colors:[],
        legend:[],
        amount: 0
    }
    data.forEach((item: any) => {
      dataGraph.amount+= item.count;
      dataGraph.colors.push(item.color);
      dataGraph.data.push(item.count);
      dataGraph.legend.push(item.label)
    });
    dataGraph.original = data;
    dataGraph.graphicCaption = this.translate.instant('dashboard-reports.num-complaints');
    dataGraph.legendCaption = data.legendCaption;
    return dataGraph;
  }

  configureData(data:any){
    let item: any={
          data:[],
          colors:[],
          legend:[],
          amount: 0
      }
      data.sourceData.forEach((sourceData:any) => {
        item.amount+= sourceData.count;
        item.colors.push(sourceData.color);
        item.data.push(sourceData.count);
      });

      item.original = data.sourceData;
      item.graphicCaption = data.graphicCaption;
      item.legendCaption = data.legendCaption;
      return item;
  }

  saveAsPng(tooltip: MatTooltip, graph: string){
    let documentObject:any = document;
    let that = this;
    // that.reportGraph.disabledSaveAsPng = true;
    tooltip.hide();
    let config: any = {
      documentPrint: documentObject.querySelector(graph),
      name: 'Captura',
      successCallback: (uploadResponse:any, blob:any) => {
        let dataBlob = new Blob([blob], { type: 'image/png' });
        let data = [new ClipboardItem({ [dataBlob.type]: dataBlob })];
        navigator.clipboard.write(data)
            .then(() => {}, (err) => console.log(err));
        this.loader.closeLoader(['export-file']);
        // that.reportGraph.disabledSaveAsPng = false;
        tooltip.message = this.translate.instant('results-report.image-captured');
        tooltip.show();
        setTimeout(() => {
          tooltip.hide();
        }, 1500);
        setTimeout(() => {
          tooltip.message = this.translate.instant('results-report.capture-image');
        }, 1700);
      }
    };
    this.exportService.convertToImg(config);
  }

  // saveAsPng(tooltip: MatTooltip, graph: string){
  //   let documentObject:any = document;
  //   let that = this;
  //   that.reportGraph.disabledSaveAsPng = true;
  //   tooltip.hide();
  //   // this.loader.openLoader('export-file');
  //   setTimeout(() => {
  //     let documentHtml: any = documentObject.querySelector(graph);
  //     html2canvas(documentHtml)
  //       .then(function(canvas) {
  //           canvas.toBlob((blob:any)=>{
  //               let data = [new ClipboardItem({ [blob.type]: blob })];
  //               navigator.clipboard.write(data)
  //                   .then(() => {}, (err) => console.log(err));
  //           });
  //     }).then(() => {
  //       // this.loader.closeLoader(['export-file']);
  //       that.reportGraph.disabledSaveAsPng = false;
  //       tooltip.message = this.translate.instant('results-report.image-captured');
  //       tooltip.show();
  //       setTimeout(() => {
  //         tooltip.message = this.translate.instant('results-report.capture-image');
  //         tooltip.hide();
  //       }, 2000);
  //     });
  //   }, 100);
  // }
}
